import fetch from 'isomorphic-fetch'
import { browserHistory } from 'react-router'
import geocoder from 'geocoder-geojson'
import { pendingTask, begin, end } from 'react-redux-spinner'
import {
  NEW_VENUE_REQUEST,
  NEW_VENUE,
  NEW_VENUE_ERROR,
  GEO_REQUEST
} from './types'

const APIKEY = 'AIzaSyBPoJuCDWoVLw1uSNoHToQPbKyk8h0m5Rs'

export function geoLookupRequest() {
  return {
    type: GEO_REQUEST,
    payload: { geolookup: true }
  }
}

export function createVenueRequest() {
  //console.warn('Create Venue Request')
  return {
    type: NEW_VENUE_REQUEST,
    [pendingTask]: begin,
    payload: { fetching: true }
  }
}

export function createVenueSuccess(venue) {
  //console.warn('Creating venue')
  //console.log(body)
  //console.warn(browserHistory.getCurrentLocation().state)
  browserHistory.push('/venues/')
  return {
    type: NEW_VENUE,
    [pendingTask]: end,
    payload: venue
  }
}

export function createVenueFail(error) {
  //console.error('Create venue failed: ' +error)
  return {
    type: NEW_VENUE_ERROR,
    [pendingTask]: end,
    payload: { error: error }
  }
}

export function getLatLon(venue) {
  return dispatch => {
    dispatch(geoLookupRequest())
    geocoder
      .google(venue.postcode, {
        key: APIKEY
      })
      .then(geojson => {
        console.warn('eh: ' + geojson)
        var loc = {
          type: 'Point',
          coordinates: geojson.features[0].geometry.coordinates
        }
        venue.location = loc
        console.warn('hhmmm: ' + JSON.stringify(venue))
        dispatch(saveVenue(venue))
      })
      .catch(error => console.log('Lat Lon Fail'))
  }
}

export function saveVenue(venue) {
  return dispatch => {
    dispatch(createVenueRequest())
    return fetch(`${process.env.REACT_APP_EF_API_URL}/venues/new`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        authorization: localStorage.getItem('token')
      },
      body: JSON.stringify(venue)
    })
      .then(res => res.json())
      .then(json => {
        dispatch(createVenueSuccess(json.body))
      })
      .catch(error => dispatch(createVenueFail(error)))
  }
}

export function newVenue(venue) {
  return dispatch => {
    return geocoder
      .google(venue.postcode, {
        key: APIKEY
      })
      .then(geojson => {
        //console.log(geojson)
        var loc = {
          type: 'Point',
          coordinates: geojson.features[0].geometry.coordinates
        }
        venue.location = loc
        //console.log(JSON.stringify(venue))
      })
      .then(() => {
        //console.log('do something')
        dispatch(createVenueRequest())
        return fetch(`${process.env.REACT_APP_EF_API_URL}/venues/new`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            authorization: localStorage.getItem('token')
          },
          body: JSON.stringify(venue)
        })
          .then(res => res.json())
          .then(json => {
            dispatch(createVenueSuccess(json.venue))
          })
          .catch(error => dispatch(createVenueFail(error)))
      })
  }
}



/** WEBPACK FOOTER **
 ** ./src/actions/venue.js
 **/